export default __webpack_public_path__ + "static/media/empty_state.37ac386c.png";